export default __webpack_public_path__ + "static/media/quickcam_logo.f7b0f454.svg";